import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { POSITIONS } from '../config/positions';
import { statsLeadersFiltersSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors/filters-selector';
import { RESET_FILTERS, UPDATE_FILTER_ITEM } from '../../../../../store/js/modules/statspro/stats-leaders/actions';
import { useTeamsForSeason } from '../../../../../../../common/react/hooks/use-teams-for-season';
import { statsLeadersNavSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors';
import { composeGetTranslation } from '../../../../../../../common/react/utils/translations';

const getTranslation = composeGetTranslation( 'label.statsLeaders.filters.' );

export const StatsLeadersFilters = () => {
    const dispatch = useDispatch();
    const filters = useSelector( statsLeadersFiltersSelector );
    const nav = useSelector( statsLeadersNavSelector );
    const teams = useTeamsForSeason( nav.season.id );
    
    const updateFilterItem = ( filterItem, value ) => {
        dispatch( UPDATE_FILTER_ITEM.request( { filterItem, value } ) );
    };

    const handleChange = ( key, value ) => {
        const filterItem = filters[ key ];

        const newFilterItem = filterItem.includes( value ) ?
            // eslint-disable-next-line id-length
            filterItem.filter( x => x !== value ) :
            [ ...filterItem, value ];

        updateFilterItem( key, newFilterItem );
    };

    return (
        <div className="stats-leaders-filters">
            <div className="stats-leaders-filters__item-wrapper">
                <strong>{ getTranslation( 'position' ) }</strong>
                { POSITIONS.map( ( position, i ) => (
                    <div key={ i }>
                        <label>
                            <input
                                type="checkbox"
                                value={ position.name }
                                onChange={ () => handleChange( 'positions', position.name ) }
                                checked={ filters.positions.includes( position.name ) }
                            />{' '}
                            { position.name }
                        </label>
                    </div>
                ) ) }
                <button
                    onClick={ () => updateFilterItem( 'positions', [] ) }
                >
                x
                </button>
            </div>
            <div className="stats-leaders-filters__item-wrapper">
                <strong>{ getTranslation( 'team' ) }</strong>
                { teams && teams.map( ( team, i ) => (
                    <div key={ i }>
                        <label>
                            <input
                                type="checkbox"
                                value={ team.providerId }
                                onChange={ () => handleChange( 'teams', team.providerId ) }
                                checked={ filters.teams.includes( team.providerId ) }
                            />{' '}
                            { team.name }
                        </label>
                    </div>
                ) ) }
                <button
                    onClick={ () => updateFilterItem( 'teams', [] ) }
                >
                x
                </button>
            </div>
            <div className="stats-leaders-filters__item-wrapper">
                <button
                    onClick={ () => dispatch( RESET_FILTERS.request() ) }
                >
                    { getTranslation( 'resetButtonText' ) }
                </button>
            </div>
        </div>
    );
};
